import { Button, Grid, GridList, GridListTile, makeStyles, Modal, Typography } from '@material-ui/core'

import React, { useEffect } from 'react'
import KeyboardArrowRightOutlinedIcon from '@material-ui/icons/KeyboardArrowRightOutlined';
import KeyboardArrowLeftOutlinedIcon from '@material-ui/icons/KeyboardArrowLeftOutlined';

import Img01 from '../../images/Skup Pula (1).jpg'
import Img02 from '../../images/Skup Pula (2).JPG'
import Img03 from '../../images/Skup Pula (3).JPG'
import Img04 from '../../images/Skup Pula (4).JPG'
import Img05 from '../../images/Skup Pula (5).JPG'
import Img06 from '../../images/Skup Pula (6).JPG'
import Img07 from '../../images/Skup Pula (7).JPG'
import Img08 from '../../images/Skup Pula (8).jpg'
import Img09 from '../../images/Skup Pula (9).jpg'
import Img10 from '../../images/Skup Pula (10).JPG'
import Img11 from '../../images/Skup Pula (11).JPG'
import Img12 from '../../images/Skup Pula (12).JPG'
import Img13 from '../../images/Skup Pula (13).JPG'
import Img14 from '../../images/Skup Pula (14).JPG'
import Img15 from '../../images/Skup Pula (15).JPG'
import Img16 from '../../images/Skup Pula (16).JPG'
import Img17 from '../../images/Skup Pula (17).JPG'

function Gallery_Location() {

    const [open, setOpen] = React.useState(false);
    const [imageIndx,setImageIndx] = React.useState(null)

    const image_array =  [Img01,Img02,Img03,Img04,Img05,Img06,Img07,Img08,Img09,Img10,Img11,Img12,Img13,Img14,Img15,Img16,Img17]

    useEffect(()=>{

    },[imageIndx])
  
  	const openNextImage=(indx)=>{
      if(indx==-1){
        setImageIndx(17)
      }
      else if(indx == image_array.length){
        setImageIndx(0)
      }
      else{
        setImageIndx(indx)
      }
     
    }
    const handleOpen = (indx) => {
      if(window.innerWidth > 960){
        setImageIndx(indx)
        setOpen(true);
      }


      };

      const handleClose = () => {
        setOpen(false);
      };

  
  
    const useStyles = makeStyles({
        root:{
            marginTop:"50px",
            
        },
        p:{
            marginBottom:"50px"
        },
        grid:{
            backgroundImage:"url(https://www.visnjicadubrovnik.com/wp-content/uploads/2019/10/Vi%C5%A1njica-Dubrovnik-Event-venue-59-Vi%C5%A1njica-archive.jpeg)",
            color:"white",
            textAlign:"left",
            alignContent:"center",
            
        },
        slike:{
           
            
        },
        tekst:{
            marginLeft:"60px",
            marginTop:"50px",
           
        },
        root2: {
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-around',
            overflow: 'hidden',
          },
          gridList: {
            width: 500,
            height: 500,
          },
          gridList2: {
            flexWrap: 'nowrap',
            // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
            transform: 'translateZ(0)',
          },
          imgFluid: {
            maxWidth: "100%",
            height: "auto",
          },
          position:{
            position:"fixed",
            top: "50%",
            left: "50%",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            maxWidth:"80%",
            maxHeight:"80%"
          
          },
          positionButton1:{
            position:"fixed",
            top: "40%",
            left: "15%",
            fontSize:"100px",
            color:"#45B283"
            

          },
          positionButton2:{
            position:"fixed",
            top: "40%",
            left: "80%",
            fontSize:"100px",
            color:"#45B283"

          }
      
      
      });
      
      const classes = useStyles();  
    return (
        <div className={classes.root} id="slike" style={{paddingLeft:"20px",paddingRight:"20px", maxWidth: "1400px", margin: "0 auto" }}>
            <Typography align="center" variant="h4" style={{marginTop:"20px",color:"#0E1B4D",fontWeight:"bold"}}> 
            MJESTO DOGAĐANJA
            </Typography>
            <Typography align="center"  variant="h6"  className={classes.p}  color="textSecondary">
            Informacije o lokaciji i Galerija
                </Typography>
                <Grid container justify="center" spacing={3}>
                <Grid item md={12} 
                style={{padding:"0 0 0 10px"}}
                xs={12}>
      
      <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d21352.614989383113!2d13.840176855336265!3d44.86660461786876!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x477cd2de09337b6d%3A0x72324a3a7b4e580d!2sPula!5e0!3m2!1shr!2shr!4v1616597980231!5m2!1shr!2shr" width="100%" height="400px" frameborder="0"  allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
                
                {/* <iframe 

                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2781.571506082065!2d15.939801615442244!3d45.79981157910633!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4765d6b898bcc65b%3A0xfd34cf05f1c81ee0!2sRovinjska%20ul.%2025%2C%2010000%2C%20Zagreb!5e0!3m2!1shr!2shr!4v1610123269862!5m2!1shr!2shr" 
                width="100%" height="400px" frameborder="0"  allowfullscreen="" aria-hidden="false" tabindex="0"
               
                ></iframe>
   */}
                </Grid>
                
                </Grid>  
                <br></br>

                

{/* 
                //Galerija */}
                <Typography align="center" variant="h4" style={{marginTop:"20px",color:"#0E1B4D",fontWeight:"bold",marginBottom:"50px"}}> 
              GALERIJA
            </Typography>
                
                 <GridList className={classes.gridList2} cols={2.5}>



              
                  {
                  image_array.map((img,indx)=>{
                    return   <GridListTile style={{height:"300px",width:"500px"}}>  
                    <img src={img} className={classes.imgFluid} onClick={()=>handleOpen(indx)}/>
                    </GridListTile>
                   
                  })
                  
                  }
              



                 </GridList>
               <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        style={{opacity:"1"}}
        onKeyDown={(e)=>{
          if(e.keyCode==39){
            openNextImage(imageIndx+1)
          }
          if(e.keyCode==37){
            openNextImage(imageIndx-1)
          }
          console.log(e.keyCode)
        }}
      >
        <div>
         <img src={image_array[imageIndx]} className={classes.position}/> 
         <KeyboardArrowLeftOutlinedIcon variant="contained"  color="secondary" className={classes.positionButton1} onClick={()=>openNextImage(imageIndx-1)}></KeyboardArrowLeftOutlinedIcon>
         <KeyboardArrowRightOutlinedIcon variant="contained" color="secondary" className={classes.positionButton2}  onClick={()=>openNextImage((imageIndx+1))}>Sljedeca</KeyboardArrowRightOutlinedIcon>
         </div>
      </Modal>
     
      
        </div>
    )
}

export default Gallery_Location
